import React from 'react';

import {
  Breakpoints,
  TextCustom,
  TextAppearance,
  TextSize,
  TextWeight,
  TextColor,
  TextLineHeight,
  Spinner,
  ThemeProvider,
} from '@vw-marketing/us-components';
import { useMyVwContext } from '../../../../shared/hooks/use-my-vw-context';
import { applyTextTransformations } from '../../../../shared/utils/applyTextTransformations';
import { StyledLoadingContainer } from './styled';
import { useVehicle } from '../../../../app/providers/VehicleContext';

export const RemoveVehicleConfirmationLoading = () => {
  const { translationHandler } = useMyVwContext();
  const { userPreferredVehicle } = useVehicle();
  const vehicleInfo = `${userPreferredVehicle?.modelYear || ''} ${userPreferredVehicle?.modelName || ''}`.trim();
  const replaceAllYearModel = (text: string, replacement: string): string => {
    return text.replace(/year_model/g, replacement);
  };

  return (
    <ThemeProvider theme="main">
      <StyledLoadingContainer>
        <TextCustom
          appearance={TextAppearance.copy200}
          style={{
            [Breakpoints.default]: {
              fontSize: TextSize.TextSize20,
              fontWeight: TextWeight.bold,
              color: TextColor.primary,
              lineHeight: TextLineHeight.TextLineHeight32,
            },
            [Breakpoints.b1920]: {
              fontSize: TextSize.TextSize24,
              fontWeight: TextWeight.bold,
              color: TextColor.primary,
              lineHeight: TextLineHeight.TextLineHeight36,
            },
          }}
        >
          {applyTextTransformations(
            replaceAllYearModel(
              translationHandler(
                'vehicleManagement.removeVehicle.confirmation.loading',
              ),
              vehicleInfo,
            ),
            ['myVW'],
          )}
        </TextCustom>
        <Spinner variant="x-large" />
      </StyledLoadingContainer>
    </ThemeProvider>
  );
};
